import { useEffect, useState } from 'react';
import { API_BASE_URL } from '@/lib/api';

export const DEFAULT_CONTENT = {
  landing: {
    event_label: 'Thomas Molins 30-års fødselsdag',
    heading: 'Velkommen til Molin30',
    description: "Event siden for Thomas Molin Christensen's 30 års fødselsdag.",
    invitation_placeholder: 'Indtast invitationskode',
    access_button_label: 'Gæsteadgang',
  },
  event_information: {
    title: 'Eventbriefing',
    short_description: 'Se eventdetaljer og send dit RSVP-svar.',
    date_text: '27. februar 2027',
    time_text: '',
    location_text: 'Meldes ud senere',
    practical_information: '',
  },
  contact: {
    contact_name: 'Eventadmin',
    contact_email: '',
    contact_text: 'Kontakt arrangøren, hvis du har spørgsmål eller problemer med adgang.',
  },
  accommodation: {
    heading: 'Overnatning',
    description: 'Information om overnatning til Molin30-eventet.',
    practical_information: 'Overnatningsdetaljer deles tættere på eventdatoen. Kig forbi igen for opdateringer om sted, check-in-tider og praktisk info.',
  },
  faq: [
    { id: 'login', question: 'Hvordan logger jeg ind?', answer: 'Brug din private e-mail og den adgangskode, du valgte ved registrering.', sort_order: 1, enabled: true },
    { id: 'qr', question: 'Hvor finder jeg min QR-kode?', answer: 'Gå til Min profil og tryk på QR-koden for at åbne den i stor visning.', sort_order: 2, enabled: true },
    { id: 'rsvp', question: 'Hvordan ændrer jeg mit RSVP?', answer: 'Gå til Eventbriefing og send dit svar igen. Det nye svar erstatter det gamle.', sort_order: 3, enabled: true },
    { id: 'music', question: 'Hvordan ønsker jeg musik?', answer: 'Gå til Musikønsker, søg efter en sang og tilføj den til køen. DJ-bordet bestemmer rækkefølgen.', sort_order: 4, enabled: true },
    { id: 'photos', question: 'Hvordan deler jeg billeder?', answer: 'Gå til Fotoprogram, vælg eller tag et billede og del det. Udvalgte billeder kan vises i diasshowet.', sort_order: 5, enabled: true },
    { id: 'bar', question: 'Hvordan bestiller jeg i baren?', answer: 'Gå til Barbestilling, vælg drikkevarer og send din bestilling.', sort_order: 6, enabled: true },
    { id: 'support', question: 'Hvem kontakter jeg, hvis noget ikke virker?', answer: 'Kontakt arrangøren eller personalet ved check-in. De kan hjælpe med login, QR-kode og adgang.', sort_order: 7, enabled: true },
    { id: 'plus-one', question: 'Kan jeg tage en gæst med?', answer: 'Hvis du har mulighed for ledsager, står det i dit RSVP og på din profil.', sort_order: 8, enabled: true },
    { id: 'overnight', question: 'Hvor finder jeg information om overnatning?', answer: 'Gå til Overnatning i gæsteportalen. Hvis der ikke står detaljer endnu, kommer de senere.', sort_order: 9, enabled: true },
    { id: 'boss', question: 'Hvem er chefen i aften?', answer: 'Thomas har officielt titlen som fødselsdagsdirektør. Resten af organisationen rapporterer til dansegulvet.', sort_order: 10, enabled: true },
    { id: 'error-40', question: 'Hvad betyder Fejl 40?', answer: 'Det betyder normalt, at fejlen sidder cirka 40 cm fra skærmen. I aften løses den med et smil og eventuelt en ny drink.', sort_order: 11, enabled: true },
    { id: 'dresscode', question: 'Er der en dresscode?', answer: 'Kom festklar. Hvis outfittet kan klare både middag og dansegulv, er du godt kørende.', sort_order: 12, enabled: true },
    { id: 'it', question: 'Findes der IT-hjælp?', answer: 'Ja, men den arbejder primært med genstart af stemning, fejlfinding i musikkøen og akut QR-ro.', sort_order: 13, enabled: true },
  ],
};

export function mergeContent(content) {
  const source = content || {};
  return {
    landing: { ...DEFAULT_CONTENT.landing, ...(source.landing || {}) },
    event_information: { ...DEFAULT_CONTENT.event_information, ...(source.event_information || {}) },
    contact: { ...DEFAULT_CONTENT.contact, ...(source.contact || {}) },
    accommodation: { ...DEFAULT_CONTENT.accommodation, ...(source.accommodation || {}) },
    faq: Array.isArray(source.faq) && source.faq.length ? source.faq : DEFAULT_CONTENT.faq,
  };
}

export function usePublicContent() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/content/public`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!cancelled && data?.content) {
          setContent(mergeContent(data.content));
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return content;
}
